export enum FileName {
  taxExemption = "taxexemption",
  resale = "resale",
}
